import React from 'react';
import { matchPath } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import useRouter from 'utils/useRouter';
import { NavigationListItem } from './components';
import { canAccessAssistenciaNavigation } from 'constants/assistenciaNavigation';
import { ADMIN_ROLE_OPTIONS } from 'views/UsersDetail/components/Forms/permissionsConfig';

const ASSISTENCIA_MENU_PAGES = ['adm', 'painelAssistencias', 'certificados', 'senhas', 'cadastros'];

const isAssistenciaSubmenuPage = (pageKey) =>
  ASSISTENCIA_MENU_PAGES.includes(pageKey);

const isReadEnabled = (permissionEntry) => {
  const read = permissionEntry?.read;
  return read === true || read === 'true' || read === 1;
};

const hasAssistenciaPageRead = (user, pageKey) => {
  if (!canAccessAssistenciaNavigation(user)) {
    return false;
  }

  if (pageKey === 'adm') {
    return ADMIN_ROLE_OPTIONS.includes(user?.permissionWebAssistencia?.adm);
  }

  if (isReadEnabled(user?.permissionWebAssistencia?.[pageKey])) {
    return true;
  }

  if (pageKey === 'painelAssistencias') {
    return isReadEnabled(user?.permission?.assistencias);
  }

  return false;
};

const hasPageReadPermission = (user, pageKey) => {
  if (!user || !pageKey) {
    return false;
  }

  // Menu principal Assistencias — comportamento original (só permission.assistencias)
  if (pageKey === 'assistencias') {
    return isReadEnabled(user?.permission?.assistencias);
  }

  // Submenus Web Assistência — e-mail autorizado + permissões específicas
  if (isAssistenciaSubmenuPage(pageKey)) {
    return hasAssistenciaPageRead(user, pageKey);
  }

  // Mapas: um único item no menu; acesso com maps ou mapsunits
  if (pageKey === 'maps') {
    return (
      isReadEnabled(user.permission?.maps) ||
      isReadEnabled(user.permission?.mapsunits)
    );
  }

  // Suporte Orange: tag atual supportOrange + legado remoteaccess
  if (pageKey === 'supportOrange') {
    return (
      isReadEnabled(user.permission?.supportOrange) ||
      isReadEnabled(user.permission?.remoteaccess)
    );
  }

  return isReadEnabled(user.permission?.[pageKey]);
};

const NavigationList = (props) => {
  const { pages, router, ...rest } = props;

  const user = JSON.parse(localStorage.getItem('userData') || 'null');

  return (
    <Nav className="flex-column">
      {pages.filter(i => {
        if (i.page === "logout") {
          return true;
        }

        if (!i.page) {
          return false;
        }

        // Itens com filhos: exibe o menu pai somente se ao menos um filho tiver acesso
        if (i.children && Array.isArray(i.children)) {
          return i.children.some(child => {
            if (!child.page) return false;
            return hasPageReadPermission(user, child.page);
          });
        }

        return hasPageReadPermission(user, i.page);
      })
        .reduce(
          (items, page) => reduceChildRoutes({ items, page, router, ...rest }),
          []
        )}
    </Nav>
  );
};

const reduceChildRoutes = (props) => {
  const { router, items, page, depth } = props;

  if (page.children) {
    const open = matchPath(router.location.pathname, {
      path: page.href,
      exact: false
    });

    items.push(
      <NavigationListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        label={page.label}
        open={Boolean(open)}
        title={page.title}
      >
        <NavigationList
          depth={depth + 1}
          pages={page.children}
          router={router}
        />
      </NavigationListItem>
    );
  } else {
    items.push(
      <NavigationListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        label={page.label}
        title={page.title}
      />
    );
  }

  return items;
};

const Navigation = (props) => {
  const { title, pages, component: Component, ...rest } = props;

  const router = useRouter();

  return (
    <Component {...rest} className={'mb-3'}>
      {title && <div className="text-uppercase small mb-2 text-muted fs-6 fw-light">{title}</div>}
      <NavigationList
        depth={0}
        pages={pages}
        router={router}
      />
    </Component>
  )
}
export default Navigation;
